import React, { useState, useEffect } from "react";
import Profile from "./Profile";
import Card from "./Card";
import "./style.css";
import "react-google-reviews/dist/index.css";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';


const getTheme = (color) => createTheme({
  palette: {
	primary: { main: color || '#229626', contrastText: "#fff" },
  },
});


const App = (props) => {
	const [profileData, setProfileData] = useState(null);
	const preview = props.preview === "true" || false;
	const card = props.card === "true" || false;
	const theme = getTheme(props.color);

	useEffect(() => {
		async function fetchProfile() {
			try {
				let identifier;
				if (card) {
					// In card mode, get companyId from URL param 'p'
					const urlParams = new URLSearchParams(window.location.search);
					identifier = urlParams.get('slug');
					console.log("identifier", identifier);
					
					if (!identifier) {
						console.error("No company ID found in URL parameter 'p'");
						return;
					}

					const response = await fetch("https://c9rtj2s6a4.execute-api.eu-west-1.amazonaws.com/prod/companies/get-by-id", {
						method: "POST",
						headers: { "Content-Type": "application/json" },
						body: JSON.stringify({ companyId: identifier })
					});
					const data = await response.json();
					setProfileData(data);
				} else {
					// In profile mode, use the existing slug-based logic
					let slug;
					if (preview) {
						// Get slug from URL query parameter in preview mode
						const urlParams = new URLSearchParams(window.location.search);
						slug = urlParams.get('slug');
					} else {
						// Get slug from URL path in normal mode
						const pathSegments = window.location.pathname.split('/').filter(Boolean);
						slug = pathSegments[pathSegments.length - 1];
					}

					if (!slug) {
						console.error("No slug found in URL");
						return;
					}

					const response = await fetch("https://c9rtj2s6a4.execute-api.eu-west-1.amazonaws.com/prod/companies/get-by-slug", {
						method: "POST",
						headers: { "Content-Type": "application/json" },
						body: JSON.stringify({ slug })
					});
					const data = await response.json();
					setProfileData(data);
				}
			} catch (error) {
				console.error("Error fetching profile data:", error);
			}
		}
		fetchProfile();
	}, [preview, card]);

	console.log("profileData", profileData);
	return (
		<ThemeProvider theme={theme}>
			<div id="react-wp-app">
				{!profileData ? (
					<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
						<CircularProgress color="primary" />
					</div>
				) : (
					card ? <Card {...profileData} profileVerified={profileData.profileVerified} profileStatus={profileData.profileStatus} /> : <Profile {...profileData} />
				)}
			</div>
		</ThemeProvider>
	);
};

export default App;